// extracted by mini-css-extract-plugin
export default {"vendorType":"vendorType__OGNjY","typeLocation":"typeLocation__Y2I2O","dot":"dot__MjQyN"};